/**
 * Abre uma janela de impressão contendo APENAS o conteúdo do relatório,
 * sem o sidebar, header ou qualquer outra parte do dashboard.
 */
export function printContent(title, htmlRef) {
  const html = htmlRef?.current?.innerHTML;
  if (!html) return;

  const win = window.open('', '_blank', 'width=960,height=700');
  win.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8" />
  <title>${title}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Arial', sans-serif;
      font-size: 11pt;
      color: #2C1E16;
      padding: 20mm 15mm;
      background: white;
    }
    h2 { font-size: 14pt; color: #832C11; margin-bottom: 6pt; }
    h3 { font-size: 11pt; color: #832C11; margin-bottom: 8pt; margin-top: 12pt; border-bottom: 1px solid #ddd; padding-bottom: 4pt; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 12pt; font-size: 10pt; }
    th { background: #FAF8F5; font-weight: bold; font-size: 9pt; text-align: left; padding: 5pt 6pt; border: 1px solid #e5e0db; }
    td { padding: 4pt 6pt; border: 1px solid #e5e0db; vertical-align: top; }
    tr:nth-child(even) td { background: #fdfcfb; }
    .page-break-before { page-break-before: always; }
    .page-break-avoid { page-break-inside: avoid; }
    p { margin-bottom: 3pt; font-size: 10pt; }
    strong { font-weight: bold; }
    /* Reset Tailwind classes for print */
    .font-body, .font-dashboard { font-family: inherit; }
    .text-brand-primary, .text-brand-dark { color: #832C11; }
    .text-brand-text { color: #2C1E16; }
    .text-brand-text-muted { color: #7A6558; }
    .font-bold { font-weight: bold; }
    .font-semibold { font-weight: 600; }
    .font-mono { font-family: monospace; }
    .border-b-2 { border-bottom: 2px solid #832C11; }
    .border-b { border-bottom: 1px solid #e5e0db; }
    .border-dashed { border-style: dashed !important; }
    .rounded-lg { border-radius: 4pt; }
    .bg-brand-bg, .bg-brand-bg\\/50 { background: #FAF8F5; }
    .border { border: 1px solid #e5e0db; }
    .border-brand-border { border-color: #e5e0db; }
    .w-full { width: 100%; }
    .flex { display: flex; }
    .flex-1 { flex: 1; }
    .justify-between { justify-content: space-between; }
    .items-start { align-items: flex-start; }
    .items-center { align-items: center; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .text-left { text-align: left; }
    .text-xs { font-size: 9pt; }
    .text-sm { font-size: 10pt; }
    .text-lg { font-size: 13pt; }
    .text-xl { font-size: 14pt; }
    .mb-3 { margin-bottom: 6pt; }
    .mb-4 { margin-bottom: 8pt; }
    .mb-6 { margin-bottom: 12pt; }
    .mb-8 { margin-bottom: 16pt; }
    .mt-3 { margin-top: 6pt; }
    .mt-0\\.5 { margin-top: 2pt; }
    .pb-2 { padding-bottom: 4pt; }
    .pb-4 { padding-bottom: 8pt; }
    .pt-3 { padding-top: 6pt; }
    .pt-4 { padding-top: 8pt; }
    .py-1 { padding-top: 2pt; padding-bottom: 2pt; }
    .py-2 { padding-top: 4pt; padding-bottom: 4pt; }
    .px-3 { padding-left: 6pt; padding-right: 6pt; }
    .p-4 { padding: 8pt; }
    .space-y-6 > * + * { margin-top: 12pt; }
    /* Status badges */
    .inline-flex { display: inline-flex; }
    .rounded-full { border-radius: 999pt; }
    .px-2 { padding-left: 4pt; padding-right: 4pt; }
    .py-0\\.5 { padding-top: 1pt; padding-bottom: 1pt; }
    .bg-green-100 { background: #dcfce7; }
    .text-green-700 { color: #15803d; }
    .bg-amber-100 { background: #fef9c3; }
    .text-amber-700 { color: #a16207; }
    .bg-blue-100 { background: #dbeafe; }
    .text-blue-700 { color: #1d4ed8; }
    .bg-red-100 { background: #fee2e2; }
    .text-red-700 { color: #b91c1c; }
    @media print {
      body { padding: 0; }
      @page { margin: 15mm; }
    }
  </style>
</head>
<body>
${html}
</body>
</html>`);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); win.close(); }, 600);
}
